import { render } from "./ScormPlayer.vue?vue&type=template&id=6141cf8e&scoped=true"
import script from "./ScormPlayer.vue?vue&type=script&lang=js"
export * from "./ScormPlayer.vue?vue&type=script&lang=js"

import "./ScormPlayer.vue?vue&type=style&index=0&id=6141cf8e&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6141cf8e"]])

export default __exports__